import type { BrandConfig } from './types';

/**
 * TagadaPay default branding configuration.
 *
 * Per-URL `VITE_*` env-var overrides exist to support whitelabel staging /
 * regional tagada deploys (e.g. `dev.tagada.io` with a different docs URL).
 * They have no effect in partner mode (partner hosts resolve their brand
 * from PARTNERS in `config/partners.ts`, never this file).
 */
export const tagadapay: BrandConfig = {
  appName: 'TagadaPay',
  appDescription: 'Comprehensive CRM solution for managing customers, payments, and subscriptions',
  companyName: 'TagadaPay SAS',

  appUrl: import.meta.env.VITE_LANDING_URL || 'https://tagada.io',
  docsUrl: import.meta.env.VITE_DOCS_URL || 'https://docs.tagada.io',
  helpCenterUrl: import.meta.env.VITE_HELP_CENTER_URL || 'https://help.tagada.io',
  supportUrl: import.meta.env.VITE_SUPPORT_URL || 'https://tagada.io/support',

  logo: '/tagada-logo.png',
  logoDark: '/tagada-logo-white.png',
  favicon: '/favicon.png',
  defaultIntegrationLogo: '/integrations/tagadapay-logo.png',

  hubName: 'Tagada Hub',
  hubUrl: import.meta.env.VITE_HUB_URL || 'https://hub.tagada.io',

  calComTeamSlug: 'tagada',

  primaryColor: '#15803d',
  accentColor: '#166534',

  supportEmail: import.meta.env.VITE_SUPPORT_EMAIL || 'support@tagada.io',

  features: {
    showRequestFeature: true,
    showSocialLinks: true,
    demoSeeding: true,
    showHelpVideos: true,
    showHub: true,
    showCalCom: true,
  },

  socialLinks: {
    twitter: 'https://twitter.com/tagadapay',
    discord: 'https://discord.gg/tagadapay',
  },
};

